// src/services/notificationService.js
import authService from './authService';
import { API_BASE_URL } from './config';

const API_BASE = `${API_BASE_URL}/notifications`;

const authFetch = async (url, options = {}) => {
  const makeHeaders = () => ({
    ...authService.getAuthHeaders(),
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
  });

  let res = await fetch(url, { ...options, headers: makeHeaders() });
  if (res.status === 401) {
    try {
      await authService.refreshAccessToken();
      res = await fetch(url, { ...options, headers: makeHeaders() });
    } catch {
      throw new Error('Session expired');
    }
  }
  return res.json();
};

export const getNotifications  = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return authFetch(`${API_BASE}${qs ? '?' + qs : ''}`);
};

export const getUnreadCount    = () => authFetch(`${API_BASE}/unread-count`);
export const markRead          = (id) => authFetch(`${API_BASE}/${id}/read`, { method: 'PATCH' });
export const markAllRead       = () => authFetch(`${API_BASE}/read-all`, { method: 'PATCH' });
export const deleteNotification= (id) => authFetch(`${API_BASE}/${id}`, { method: 'DELETE' });
export const clearAll          = () => authFetch(`${API_BASE}/clear-all`, { method: 'DELETE' });
